module.exports = __webpack_public_path__ + "static/media/powered-by-logo.a43d1377.png";